<app-header>
    <button mat-icon-button (click)="sidenav.toggle()" fxShow="true" fxHide.gt-sm>
        <mat-icon>menu</mat-icon>
    </button>
</app-header>
<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side" opened>
        <app-side-nav></app-side-nav>
    </mat-sidenav>
    <mat-sidenav-content>
        <main class="sidenav-content">
            <div class="main-content">
                <!-- <mat-progress-bar *ngIf="loading" color="accent" mode="indeterminate"></mat-progress-bar> -->
                <router-outlet></router-outlet>
            </div>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>